import { ReservedProduction } from "../blood-management/blood-management-types";

export default class ReservedBloodProductsContext {

  private static reservedBloodProducts: ReservedProduction;

  public static get(): ReservedProduction {
    return this.reservedBloodProducts;
  }

  public static set(reservedBloodProducts: ReservedProduction): void {
    this.reservedBloodProducts = reservedBloodProducts;
  }
}
